import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { SystemMessage, SystemMessagePayload } from "@/models/system-message";
import { ISystemMessagesApi } from "./ISystemMessagesApi";

@injectable()
export class SystemMessagesApi implements ISystemMessagesApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/system-messages";

  async getAll(): Promise<SystemMessage[]> {
    const { data } = await this.client.get<SystemMessage[]>(this.baseUrl);
    return data;
  }

  async create(payload: SystemMessagePayload): Promise<SystemMessage> {
    const { data } = await this.client.post<SystemMessage>(this.baseUrl, payload);
    return data;
  }

  async update(id: string, payload: Partial<SystemMessagePayload>): Promise<SystemMessage> {
    const { data } = await this.client.patch<SystemMessage>(`${this.baseUrl}/${id}`, payload);
    return data;
  }

  async remove(id: string): Promise<void> {
    await this.client.delete(`${this.baseUrl}/${id}`);
  }
}
